const BackButtonSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25px"
      height="25px"
      viewBox="0 0 25 25"
      version="1.1"
    >
      <g id="surface1">
        <path
          style={{
            stroke: "none",
            fillRule: "nonzero",
            fill: "rgb(100%,100%,100%)",
            fillOpacity: 1,
          }}
          d="M 25 14.300781 C 25 17.144531 23.871094 19.871094 21.863281 21.878906 C 19.851562 23.886719 17.128906 25.015625 14.285156 25.015625 L 1.339844 25.015625 C 0.984375 25.015625 0.644531 24.875 0.390625 24.625 C 0.140625 24.375 0 24.03125 0 23.675781 C 0 23.324219 0.140625 22.980469 0.390625 22.730469 C 0.644531 22.480469 0.984375 22.339844 1.339844 22.339844 L 14.285156 22.339844 C 16.417969 22.339844 18.460938 21.492188 19.96875 19.984375 C 21.472656 18.476562 22.320312 16.433594 22.320312 14.300781 C 22.320312 12.171875 21.472656 10.128906 19.96875 8.621094 C 18.460938 7.113281 16.417969 6.265625 14.285156 6.265625 L 4.570312 6.265625 L 5.855469 7.550781 C 6.109375 7.804688 6.25 8.144531 6.25 8.5 C 6.25 8.855469 6.109375 9.195312 5.855469 9.445312 C 5.605469 9.695312 5.265625 9.835938 4.910156 9.835938 C 4.554688 9.835938 4.214844 9.695312 3.964844 9.445312 L 0.390625 5.875 C 0.140625 5.621094 0 5.28125 0 4.925781 C 0 4.574219 0.140625 4.230469 0.390625 3.980469 L 3.964844 0.410156 C 4.085938 0.277344 4.234375 0.171875 4.398438 0.0976562 C 4.5625 0.0273438 4.742188 -0.0117188 4.921875 -0.015625 C 5.101562 -0.0195312 5.277344 0.0117188 5.445312 0.0820312 C 5.613281 0.148438 5.761719 0.25 5.890625 0.375 C 6.019531 0.503906 6.117188 0.652344 6.1875 0.820312 C 6.253906 0.988281 6.285156 1.167969 6.28125 1.347656 C 6.28125 1.527344 6.242188 1.703125 6.167969 1.867188 C 6.09375 2.03125 5.988281 2.179688 5.855469 2.300781 L 4.570312 3.589844 L 14.285156 3.589844 C 17.128906 3.589844 19.851562 4.71875 21.863281 6.726562 C 23.871094 8.734375 25 11.460938 25 14.300781 Z M 25 14.300781 "
        />
      </g>
    </svg>
  );
};

export default BackButtonSVG;
